module.exports = __webpack_public_path__ + "static/img/40017 (3).8116c2b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40017 (3).webp
// module id = 2clh
// module chunks = 14